// extracted by mini-css-extract-plugin
export default {"wrapper":"C6-z","play":"D6-z"};